import React, { Fragment, useEffect, useState } from "react";
import { InfoCircleTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import moment from "moment";
import {
  setTableListData,
  setTableActionDetails,
} from "../../actions/tableListing/tableListDataAction";
import { buildLogisticTableActionDetails } from "../../helper/logisticTableAction";

const LogisticAllTab = ({
  tabTableData,
  isLoading,
  OnhandleTableSortColumn,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isO2WPage =
    window.location.pathname.split("/")[1] === "dashboard" ? true : false;

  const tableSorting = useSelector(
    (state) =>
      state.TableSortingData.tableListData || {
        sortColumn: null,
        orderBy: null,
      }
  );

  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    if (tabTableData.logisticsAllTab?.length > 0) {
      setTotalRecords(tabTableData.totalRecords);
      setPageNo(Number(tabTableData.currentPage));
      dispatch(setTableListData(tabTableData.logisticsAllTab));
    } else {
      setTotalRecords(0);
      setPageNo(1);
    }
  }, [tabTableData.logisticsAllTab]);

  const handleTableAscDes = (pagination, filters, sorter) => {
    const sortOrder = sorter.order;
    const sortField = sorter.field;
    OnhandleTableSortColumn({
      sortColumn: sortField,
      orderBy:
        sortOrder === "ascend"
          ? "asc"
          : sortOrder === "descend"
            ? "desc"
            : "asc",
      currentPage: pagination.current,
    });
  };
  //// handle Overview Details page
  const handleOverviewDetailsPage = (rowData) => {
    dispatch(setTableActionDetails(buildLogisticTableActionDetails(rowData)));
    navigate(
      `/${isO2WPage ? "o2w" : "logistic"
      }/overviewDetails/all/${encodeURIComponent(
        rowData.customer_PO_Number
      )}`
    );
  };

  const tableColumns = [
    {
      title: "SAP Order No.",
      dataIndex: "sap_Order_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting?.sortColumn === "sap_Order_Number"
          ? tableSorting?.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 160,
    },
    {
      title: "PO Number",
      dataIndex: "customer_PO_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_PO_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 160,
      render: (_i, row) => {
        return (
          <div>{row.customer_PO_Number ? row.customer_PO_Number : "N/A"}</div>
        );
      },
    },
    {
      title: "Customer Name",
      dataIndex: "customer_Organization_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 250,
      render: (_i, row) => {
        return (
          <div>
            {row.customer_Organization_Name
              ? row.customer_Organization_Name
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Estimated Dispatch Date",
      dataIndex: "dispatch_Estimated",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 200,
      render: (_i, row) => {
        return (
          <div>{row.dispatch_Estimated ? moment(row.dispatch_Estimated).format("DD-MM-YYYY") : "N/A"}</div>
        );
      },
    },
    {
      title: "Actual Dispatch Date",
      dataIndex: "dispatch_Actual",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            <label>{row.dispatch_Actual ? moment(row.dispatch_Actual).format("DD-MM-YYYY") : "N/A"}</label>
          </div>
        );
      },
    },
    {
      title: "Invoice Number",
      dataIndex: "inv_No",
      sorter: true,
      showSorterTooltip: false,
      width: 160,
      sortOrder:
        tableSorting.sortColumn === "inv_No"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        if (!row.inv_No) {
          return <label>N/A</label>;
        }

        const invoices = row.inv_No.split(',');

        return (
          <div>
            {invoices.map((inv, index) => (
              <div key={index}>
                {inv.trim()}
                {index < invoices.length - 1 && ','}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      title: "Estimated Time Of Arrival",
      dataIndex: "etA_Port_Estimated",
      sorter: true,
      showSorterTooltip: false,
      width: 220,
      sortOrder:
        tableSorting.sortColumn === "etA_Port_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.etA_Port_Estimated
              ? moment(row.etA_Port_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Estimation Delivery Date",
      dataIndex: "delivery_Date_Estimated",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "delivery_Date_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 220,
      render: (_i, row) => {
        return (
          <div>
            {row.delivery_Date_Estimated
              ? moment(row.delivery_Date_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    // {
    //   title: "Actual Delivery",
    //   dataIndex: "delivery_Date_Actual",
    //   sorter: true,
    //   showSorterTooltip: false,
    //   width: 160,
    //   sortOrder:
    //     tableSorting.sortColumn === "delivery_Date_Actual"
    //       ? tableSorting.orderBy === "asc"
    //         ? "ascend"
    //         : "descend"
    //       : null,
    //   render: (_i, row) => {
    //     return (
    //       <div>
    //         {row.delivery_Date_Actual
    //           ? moment(row.delivery_Date_Actual).format("DD-MM-YYYY")
    //           : "N/A"}
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Delivery Number",
      dataIndex: "delivery_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "delivery_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return (
          <div>{row.delivery_Number ? row.delivery_Number : "N/A"}</div>
        );
      },
    },
    {
      title: "Dispatch Quantity",
      dataIndex: "dispatch_Qty",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Qty"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return (
          <div>{row.dispatch_Qty ? row.dispatch_Qty : "N/A"}</div>
        );
      },
    },
    {
      title: "Sales Unit",
      dataIndex: "sale_Unit",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "sale_Unit"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return (
          <div>{row.sale_Unit ? row.sale_Unit : "N/A"}</div>
        );
      },
    },
    {
      title: "Material Number",
      dataIndex: "material_SAP_Code",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "material_SAP_Code"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return (
          <div>{row.material_SAP_Code ? row.material_SAP_Code : "N/A"}</div>
        );
      },
    },
    {
      title: "Material Name",
      dataIndex: "material_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "material_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 240,
      render: (_i, row) => {
        return (
          <div>{row.material_Name ? row.material_Name : "N/A"}</div>
        );
      },
    },
    {
      title: "Container Number",
      dataIndex: "container_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "container_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return (
          <div>{row.container_Number ? row.container_Number : "N/A"}</div>
        );
      },
    },
    {
      title: "Truck Number",
      dataIndex: "vehicle_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "vehicle_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return (
          <div>{row.vehicle_Number ? row.vehicle_Number : "N/A"}</div>
        );
      },
    },
    {
      title: "BL/LR Number",
      dataIndex: "bL_LR_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "bL_LR_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return (
          <div>{row.bL_LR_Number ? row.bL_LR_Number : "N/A"}</div>
        );
      },
    },
    // {
    //   title: "Actual Dispatch",
    //   dataIndex: "dispatch_Actual",
    //   sorter: true,
    //   showSorterTooltip: false,
    //   width: 160,
    //   sortOrder:
    //     tableSorting.sortColumn === "dispatch_Actual"
    //       ? tableSorting.orderBy === "asc"
    //         ? "ascend"
    //         : "descend"
    //       : null,
    //   render: (_i, row) => {
    //     return (
    //       <div>
    //         <label>{row.dispatch_Actual ? row.dispatch_Actual : "N/A"}</label>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "Actual Dispatch",
    //   dataIndex: "dispatch_Actual",
    //   sorter: true,
    //   showSorterTooltip: false,
    //   width: 160,
    //   sortOrder:
    //     tableSorting.sortColumn === "dispatch_Actual"
    //       ? tableSorting.orderBy === "asc"
    //         ? "ascend"
    //         : "descend"
    //       : null,
    //   render: (_i, row) => {
    //     return (
    //       <div>
    //         <label>{row.dispatch_Actual ? row.dispatch_Actual : "N/A"}</label>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Dispatch Status",
      dataIndex: "status",
      sorter: true,
      fixed: "right",
      showSorterTooltip: false,
      width: 160,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div className="status">
            <label className="pending">{row.status}</label>
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 80,
      fixed: "right",
      render: (_i, row) => (
        <div
          className="tbl_info_details"
          onClick={() => handleOverviewDetailsPage(row)}
        >
          <InfoCircleTwoTone />
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <Table
        bordered
        scroll={{ x: 900 }}
        className="logistic_tables"
        dataSource={tabTableData.logisticsAllTab}
        loading={isLoading}
        onChange={handleTableAscDes}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "even-row" : "odd-row"
        }
        pagination={{
          total: totalRecords,
          pageNo: pageNo,
          pageSize: 10,
          responsive: true,
          showSizeChanger: false,
          current: pageNo,
          onChange: (pageNum) => setPageNo(pageNum),
        }}
        columns={tableColumns}
        rowStyle={(record, index) => ({
          backgroundColor: index % 2 === 0 ? "red" : "#ffffff",
        })}
      />
    </Fragment>
  );
};

export default LogisticAllTab;
